/**
 * 获取服务说明
 * @returns {string[]}
 */
const getServiceDescList = () => {
  return [
    '灵活宝是一款保证金预存服务，企业预存金额后拥有保证金额度，该额度全员工共享。',
    '员工在参与项目时，可以直接使用该额度缴纳保证金，项目结束后释放占用额度，释放后额度恢复，可以一直循环使用。',
    '目前只支持询比类项目保证金缴纳。',
    '支持随时退款。'
  ]
}

const useGuaranteePreSave = () => {
  return {
    getServiceDescList
  }
}

export default useGuaranteePreSave
